import axios from "axios";
import { STATUSES } from "./apiStatus";
import { base_url } from "../utils";
import { getAccesstoken } from "../helpers/utils";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

export const addUser = createAsyncThunk(
  "addUser/fetch",
  async (data, { rejectWithValue, serializeError, dispatch }) => {
    const token = getAccesstoken();
    try {
      const response = await axios.post(
        `${base_url}/digilocker/addUser`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      dispatch(setShowAlert(true));

      return response.data;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  },
  {
    serializeError: (err) => err.message,
  }
);

const addUserSlice = createSlice({
  name: "addUser",
  initialState: {
    userData: {},
    userStatus: "idle",
    error: null,
    showAlert: false,
  },
  reducers: {
    updateCreditStatus: (state, action) => {
      state.creditStatus = action.payload;
    },
    setShowAlert: (state, action) => {
      state.showAlert = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addUser.pending, (state, action) => {
        state.userStatus = STATUSES.LOADING;
      })
      .addCase(addUser.fulfilled, (state, action) => {
        state.userData = action.payload;
        state.userStatus = STATUSES.IDLE;
      })
      .addCase(addUser.rejected, (state, action) => {
        state.userStatus = STATUSES.ERROR;
      });
  },
});

export default addUserSlice.reducer;
export const { updateCreditStatus, setShowAlert } = addUserSlice.actions;
